export default __webpack_public_path__ + "ceb82a76215173c5dc5f0234b3200b1c.png";